import React from 'react';
import { calendarType, displayRange, sortedBreaks } from './calendarPresentation';

export default function SchoolCalendarBreaks({ calendar }) {
  if (!calendar.breaks.length) return <p>Nie dodano przerw w tym roku szkolnym.</p>;
  return (
    <ul className="school-calendar-breaks">
      {sortedBreaks(calendar.breaks).map(item => (
        <li key={item.breakId}><span>{item.name}</span><time>{displayRange(item)}</time></li>
      ))}
    </ul>
  );
}
SchoolCalendarBreaks.propTypes = { calendar: calendarType.isRequired };
